export default __webpack_public_path__ + "static/media/004-pig.4b2a4ea0.svg";